import ContentsTypes from "@shared/enums/contentsTypes";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
export const DescriptionSectionItem = {
    label: "Bloc d'informations",
    key: "items",
    type: ContentsCustomTypes.DESCRIPTION_SECTION_ITEM,
    children: [
        {
            label: "Titre",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Description",
            key: "description",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Icône",
            key: "icon",
            type: ContentsTypes.ICON,
            value: "",
        },
    ],
};
export const DescriptionSection = {
    label: "Section de description",
    type: ContentsCustomTypes.DESCRIPTION_SECTION,
    icon: "address-card",
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            label: "Titre",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Sous-titre",
            key: "subtitle",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Description",
            key: "description",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Image",
            key: "image",
            type: ContentsTypes.FILE_IMAGE,
            value: "",
        },
        {
            label: "Couleur de fond",
            key: "backgroundColor",
            type: ContentsTypes.COLOR_EXTENDED,
            value: "",
        },
        {
            label: "Style des bloc d'informations",
            key: "style",
            type: ContentsTypes.RADIO_GROUP,
            value: "text",
            options: [
                { label: "Texte", value: "text" },
                { label: "Carte", value: "card" },
            ],
        },
        {
            label: "Orientation des bloc d'informations",
            key: "orientation",
            type: ContentsTypes.RADIO_GROUP,
            value: "vertical",
            options: [
                { label: "Vertical", value: "vertical" },
                { label: "Horizontal", value: "horizontal" },
            ],
        },
        {
            key: "dynamicList",
            type: ContentsTypes.DYNAMIC_LIST,
            value: "",
            children: [
                {
                    key: "contentType",
                    children: [DescriptionSectionItem],
                    value: ContentsCustomTypes.DESCRIPTION_SECTION_ITEM,
                },
            ],
        },
    ],
};
